import aiee from './aiee';
import ash from './ash';
import azureOrange from './azureOrange';
import bee from './bee';
import blackAndWhite from './blackAndWhite';
import blue from './blue';
import brick from './brick';
import candy from './candy';
import cherry from './cherry';
import coldGray from './coldGray';
import counterStrike from './counterStrike';
import darkTeal from './darkTeal';
import eggplant from './eggplant';
import fxDev from './fxDev';
import highContrast from './highContrast';
import hotChocolate from './hotChocolate';
import lilac from './lilac';
import lilacRoseDark from './lilacRoseDark';
import maple from './maple';
import marine from './marine';
import matrix from './matrix';
import millenium from './millenium';
import modernDark from './modernDark';
import molecule from './molecule';
import ninjaTurtles from './ninjaTurtles';
import olive from './olive';
import original from './original';
import pamelaAnderson from './pamelaAnderson';
import plum from './plum';
import polarized from './polarized';
import powerShell from './powerShell';
import rainyDay from './rainyDay';
import raspberry from './raspberry';
import redWine from './redWine';
import rose from './rose';
import seawater from './seawater';
import slate from './slate';
import solarizedDark from './solarizedDark';
import solarizedLight from './solarizedLight';
import spruce from './spruce';
import stormClouds from './stormClouds';
import theSixtiesUSA from './theSixtiesUSA';
import tokyoDark from './tokyoDark';
import tooSexy from './tooSexy';
import travel from './travel';
import vaporTeal from './vaporTeal';
import vermillion from './vermillion';
import violetDark from './violetDark';
import water from './water';
import wmii from './wmii';

export default {
  aiee,
  ash,
  azureOrange,
  bee,
  blackAndWhite,
  blue,
  brick,
  candy,
  cherry,
  coldGray,
  counterStrike,
  darkTeal,
  eggplant,
  fxDev,
  highContrast,
  hotChocolate,
  lilac,
  lilacRoseDark,
  maple,
  marine,
  matrix,
  millenium,
  modernDark,
  molecule,
  ninjaTurtles,
  olive,
  original,
  pamelaAnderson,
  plum,
  polarized,
  powerShell,
  rainyDay,
  raspberry,
  redWine,
  rose,
  seawater,
  slate,
  solarizedDark,
  solarizedLight,
  spruce,
  stormClouds,
  theSixtiesUSA,
  tokyoDark,
  tooSexy,
  travel,
  vaporTeal,
  vermillion,
  violetDark,
  water,
  wmii,
};
